import PageHeader from '../../components/PageHeader/PageHeader';
import "../Style/style.css";
import { Row, Col, Form, Input, Checkbox, Tabs, Divider } from 'antd';
import CrudButtons from "../../components/CrudButtons/CrudButtons";
import { useState, useLayoutEffect, useRef, useEffect } from 'react';
import { getRights } from "../../redux/actions/userRights.action";
import { useSelector, useDispatch } from 'react-redux';
import { ReadCookie, } from '../../utils/readCookie';
import Tables from "../../components/Table/Tables"
import { logColumns, adminLocationColumn } from "../../utils/cols";
import { getLog } from "../../redux/actions/log.action"
import notification from '../../utils/notification'
import { getAdminLocation, addAdminLocation, deleteAdminLocation, updateAdminLocation } from '../../redux/actions/adminLocation.action';
import { TabTitle } from '../../utils/GeneralFunction';


const { TabPane } = Tabs;


const AdminLocation = ({ token }) => {
    TabTitle("Location")
    const { userRights, log, adminLocation } = useSelector(state => state)
    const [minimize, setMinimize] = useState(false);
    const [formState, setFormState] = useState('view');
    const [location_name, setLocationName] = useState('');
    const [form] = Form.useForm();
    const locationInput = useRef(null);
    const [disable, setDisable] = useState(false);
    const [locationObj, setLocationObj] = useState(null);
    const [check, setCheck] = useState(true);
    const dispatch = useDispatch();
    const id = ReadCookie('menuId');


    useEffect(() => {
        dispatch(getAdminLocation(token))
    }, [dispatch, token])

    const handleDelete = () => {
        if (locationObj) {

            dispatch(deleteAdminLocation(token, locationObj.location_id)).then((res) => {
                if (res.type === "DELETE_ADMIN_LOCATION_SUCCESS") {
                    notification("success", "Location deleted", "Location deleted successfully!");
                }
                if (res.type === "DELETE_ADMIN_LOCATION_ERROR") {
                    notification("error", res?.payload?.request?.statusText, res?.payload?.data?.data);
                }
                form.setFieldsValue({
                    name: ""
                })
                setLocationName("")
                setLocationObj(null)
                setFormState('view')
                dispatch(getAdminLocation(token, id))

            })
        }
        setFormState("view")
    }

    useEffect(() => {

        if (locationObj) {
            setFormState('view')
            form.setFieldsValue({
                id: locationObj.location_id,
                name: locationObj.location_name,
                active: locationObj.is_active,
            });
            setLocationName(locationObj.location_name)
            setCheck(locationObj.is_active)
        }

    }, [locationObj]);

    useEffect(() => {
        if (location_name === '') {
            setDisable(true)
        } else {
            setDisable(false)
        }
    }, [location_name])




    useLayoutEffect(() => {
        dispatch(getRights(token, id)).then((res) => {
            if (res.type === "GET_USER_RIGHTS_SUCCESS") {
                if (!res?.payload.can_add) {
                    setFormState("table")
                }
            }
        });
    }, [])
    useEffect(() => {
        dispatch(getLog(token, { admin_location: "admin_location" }))
    }, [dispatch, token])




    const formSave = async () => {

        await form.validateFields().then((values) => {
            if (formState === "add") {
                dispatch(addAdminLocation(token, { location_name, is_active: check }, id)).then((res) => {

                    if (res.type === "ADD_ADMIN_LOCATION_ERROR") {
                        notification("error", "Not Created", res?.payload?.data?.data)
                    }
                    if (res.type === "ADD_ADMIN_LOCATION_SUCCESS") {
                        notification("success", "Location created", "Location created successfully!");
                        form.setFieldsValue({
                            name: ""
                        })
                        setFormState("view")
                        setLocationName("")
                        setLocationObj(null)
                    }
                    dispatch(getAdminLocation(token, id))

                })

            }
            if (formState === "edit") {
                dispatch(updateAdminLocation(token, { location_name, is_active: check }, locationObj.location_id)).then((res) => {
                    if (res.type === "UPDATE_ADMIN_LOCATION_ERROR") {
                        notification("error", "Update", "Something went wrong")
                    }
                    if (res.type === "UPDATE_ADMIN_LOCATION_SUCCESS") {
                        notification("success", "Location updated", "Record updated successfully")
                    }
                    dispatch(getAdminLocation(token, id))
                })
            }

        }).catch((err) => {

        })




    }



    useEffect(() => {
        if (formState === "add") {
            locationInput.current.focus()
            form.setFieldsValue({
                cid: null,
                name: null,


            })
            setCheck(true)
            setLocationName("")
            setLocationObj(null)
        }
    }, [formState]);

    const filterReset = () => {
        setFormState("view")
        setLocationObj(null)
        setCheck(true)
        form.setFieldsValue({
            cid: null,
            name: "",
        })
        setLocationName(null)

    }


    return (
        <div className='styleContainer'>
            <div className='styleBody h-100' >
                <PageHeader title={"Admin Location"} minimize={setMinimize} check={minimize} />
                {
                    !minimize &&
                    <div className='bodyStyle' >
                        <div className='crudDiv' ><CrudButtons formType={formState} rights={userRights?.payload} formState={setFormState} disable={disable} reset={filterReset} save={formSave} onDelete={handleDelete} /></div>
                        <div className='styleContent' >
                            <Row className='tables-main-row-new' >
                                <Col xs={24} sm={24} md={10} lg={8} xl={6}>
                                    <div className='styleTable' >
                                        <Tables type="location" formState={formState} locationObj={setLocationObj} scrollX={"20rem"} source={adminLocation?.payload?.data} col={adminLocationColumn} paginate scroll={500} perPage={25} load={adminLocation.loading} rowKey="location_id" />
                                    </div>
                                </Col>
                                <Col xs={24} sm={24} md={14} lg={16} xl={18}>
                                    <div className='styleForm'  >
                                        <div className='testStyle' >
                                            <Form
                                                form={form}
                                                name="basic"
                                            >
                                                <div className='customRow styleFormUpper ' >
                                                    {locationObj !== null && !(formState === "add") &&
                                                        <div className='customCols slc'>
                                                            <Form.Item
                                                                label="ID"
                                                                name="id"
                                                                initialValue={form.getFieldValue().id}
                                                                labelCol={{ span: 10 }}
                                                                wrapperCol={{ span: 14 }}

                                                            >
                                                                <Input size='small' className='styleInput id-field-style' readOnly />

                                                            </Form.Item>
                                                        </div>


                                                    }


                                                    <div className='customCols slc'>
                                                        <Form.Item
                                                            label="Location Name"
                                                            name="name"
                                                            initialValue={form.getFieldValue().city}
                                                            labelCol={{ span: 10 }}
                                                            wrapperCol={{ span: 14 }}
                                                        >

                                                            <Input size='small' disabled={!(formState === "add" || formState === "edit")} ref={locationInput} onChange={(e) => setLocationName(e.target.value)} className='styleInput' />
                                                        </Form.Item>
                                                    </div>
                                                    <div className='customCols slc'>
                                                        <Form.Item
                                                            label="Active"
                                                            name="active"
                                                            labelCol={{ span: 10 }}
                                                            wrapperCol={{ span: 14 }}
                                                        >
                                                            <Checkbox disabled={!(formState === "add" || formState === "edit")} checked={check} onChange={(e) => setCheck(e.target.checked)} />
                                                        </Form.Item>
                                                    </div>
                                                </div>
                                            </Form>
                                        </div>

                                        <div className='modalStyle' >
                                        </div>
                                        <Divider />
                                        <div className='styleTab' >
                                            <Tabs type='card' tabBarGutter={2} defaultActiveKey="1" centered   >
                                                <TabPane tab="Log Info" key="logs"  >
                                                    <div className='tabs' >
                                                        <Tables type="company" scrollX={"50rem"} scroll={800} perPage={10} source={log?.payload?.data} col={logColumns} load={log.loading} paginate />
                                                    </div>
                                                </TabPane>
                                            </Tabs>
                                        </div>
                                    </div>
                                </Col>

                            </Row>
                        </div>
                    </div>
                }
            </div>
        </div>
    )
}


export default AdminLocation